module.exports = __webpack_public_path__ + "img/rural-ga-poster.57f12ba5.jpg";